var $$request = require('assets/lib/lib-request.js');
var proxy = require('./proxy/passportProxy');

module.exports = {
    //通过手机注册
    regByMobile: function (data, fn) {
        var _this = this;
        var params = {
            mobile: data.mobile,
            captcha: data.captcha,
            password: data.password,
            imgcode: data.imgcode,
            channel: data.channel,
            cacode: data.cacode || ''

        };


        proxy('regByMobile', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //通过账号注册
    regByEmail: function (data, fn) {
        var _this = this;
        var params = {
            email: data.email,
            password: data.password,
            appId: data.appId,
            nick: data.nick,
            source: data.source
        };

        proxy('regByEmail', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //账号登录
    loginByPassport: function (data, fn) {
        var _this = this;
        var params = {
            passport: data.passport,
            password: data.password,
            auto: data.auto,
            imgcode: data.imgcode,
            channel: data.channel//个人中心传5，生态传12
        };

        proxy('loginByPassport', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //手机号登录
    loginByCaptcha: function (data, fn) {
        var _this = this;
        var params = {
            mobile: data.mobile,
            captcha: data.captcha,
            auto: data.auto,
            imgcode: data.imgcode,
            channel: data.channel
        };

        proxy('loginByCaptcha', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //检查邮箱是否可用
    regCheck: function (email, fn) {
        var _this = this;
        var params = {
            email: email
        };

        proxy('regCheck', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //查询手机号是否被注册
    mobileHasBind: function (mobile, fn) {
        var _this = this;
        var params = {
            mobile: mobile
        };

        proxy('mobileHasBind', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //查询是否绑定手机
    passportHasMobile: function (data, fn) {
        var _this = this;
        var params = {
            passport: data.passport,
            uid: data.uid
        };

        proxy('passportHasMobile', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //获取已登录用户信息
    getUserInfo: function (fn) {
        var _this = this;
        proxy('getUserInfo', '', function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //通过uid获取用户信息
    getByFocusId: function (uid, fn) {
        var _this = this;
        var params = {
            id: uid
        };

        proxy('getByFocusId', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //成功登陆用户绑定手机号
    bindMobile: function (mobile, captcha, source, fn) {
        var _this = this;
        var params = {
            mobile: mobile,
            captcha: captcha,
            source: source//0是wap（默认），1是PC
        };

        proxy('bindMobile', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //判断原始绑定手机号是否正确
    verifyOriginalBind: function (mobile, captcha, fn) {
        var _this = this;
        var params = {
            mobile: mobile,
            captcha: captcha
        };

        proxy('verifyOriginalBind', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //修改绑定手机
    modifyBind: function (mobile, captcha, token, fn) {
        var _this = this;
        var params = {
            mobile: mobile,
            captcha: captcha,
            token: token
        };

        proxy('modifyBind', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //获取图形验证码
    getCaptcha: function (fn) {
        var _this = this;
        proxy('getCaptcha', '', function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //验证码认证
    verifyCaptcha: function (input, fn) {
        var _this = this;
        var params = {
            input: input
        };

        proxy('verifyCaptcha', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //判断是否需要验证码
    isNeeded: function (input, fn) {
        var _this = this;
        proxy('isNeeded', '', function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //获取短信验证码
    getMobileCaptcha: function (data, fn) {
        var _this = this;
        var params = {
            mobile: data.mobile,//s
            type: data.type,//s；1注册 2登录 3绑定手机 5重置密码 6验证原始绑定手机号（未上线） 7换绑新手机号（未上线）
            imgcode: data.imgcode,//r
            channel: data.channel,//r;用户中心传5，生态传12
            cacode: data.cacode || ''
        };

        proxy('getMobileCaptcha', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    // 获取短信验证码 add 腾讯验证
    getMobileCaptchaTx: function (data, fn) {
        var _this = this;
        var params = {
            mobile: data.mobile, // s
            type: data.type, // s；1注册 2登录 3绑定手机 5重置密码 6验证原始绑定手机号（未上线） 7换绑新手机号（未上线）
            ticket: data.ticket, // r
            randstr: data.randstr,
            channel: data.channel, // r;用户中心传5，生态传12
            smsType: data.smsType || '', // 语音验证码传2
            cacode: data.cacode || '',
            token: window.fclogin_focus_token || null
        };

        proxy('getMobileCaptchaTx', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //获取邮箱验证
    sendEmailCaptcha: function (email, type, fn) {
        var _this = this;
        var params = {
            email: email,
            type: type//验证码类型,1:注册
        };

        proxy('sendEmailCaptcha', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //短信验证校验码
    vertifyMobileCaptcha: function (mobile, captcha, type, fn) {
        var _this = this;
        var params = {
            mobile: mobile,
            type: type,//1注册 2登录 3绑定手机 5重置密码 6验证原始绑定手机号（未上线） 7换绑新手机号（未上线）
            captcha: captcha
        };

        proxy('vertifyMobileCaptcha', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //通过旧密码修改新密码
    modifyWithOldPwd: function (oldPwd, newPwd, fn) {
        var _this = this;
        var params = {
            oldPwd: oldPwd,//s
            newPwd: newPwd//s
        };

        proxy('modifyWithOldPwd', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //验证旧密码
    verifyOldPwd: function (oldPwd, fn) {
        var _this = this;
        var params = {
            oldPwd: oldPwd // s
        };

        proxy('verifyOldPwd', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //手机号重置密码
    resetByMobile: function (token, password, fn) {
        var _this = this;
        var params = {
            token: token, // s;第一步验证手机验证码接口返回
            password: password // s;新密码
        };

        proxy('resetByMobile', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //邮箱重置密码
    resetByEmail: function (token, password, fn) {
        var _this = this;
        var params = {
            token: token, // s;第二步页面埋下的token
            password: password // s;新密码
        };

        proxy('resetByEmail', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //手机短信验证码确认
    passwordVerifyCaptcha: function (mobile, captcha, cacode, fn) {
        var _this = this;
        var params = {
            mobile: mobile, // s;
            captcha: captcha, // s;
            cacode: cacode || ''
        };

        proxy('passwordVerifyCaptcha', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    },
    //发送邮件
    sendVerifyEmail: function (userName, source, fn) {
        var _this = this;
        var params = {
            userName: userName, // s;邮箱
            source: source // s;0是wap 1是pc(默认)
        };

        proxy('sendVerifyEmail', params, function (res) {
            if (typeof fn === 'function') {
                fn(res);
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/model/passport.js